module.exports = __webpack_public_path__ + "img/yutu.e242c9ac.gif";